import type { ReactElement } from 'react'

import type { StyledComponentProps } from '@subaio/components'

import { components } from 'components/DefaultMdxComponents'

import { findElement } from './findElement'

export const getDescription = (element: ReactElement) => {
	const description = findElement<
		ReactElement<StyledComponentProps<(typeof components)['Description']>, (typeof components)['Description']>
	>(element, ({ type }) => type === components.Description)

	if (!description) throw new Error('Could not extract the description from the document')

	return description.props.children
}
